// extracted by mini-css-extract-plugin
export default {"recommendationTextLinks":"RecommendationsTextLinksLayout_recommendationTextLinks__nW4FO"};